module.exports = __webpack_public_path__ + "media/images/homes/TrackCookingTimes-0fbbe9579c17906fcb020bbc7339836c.png";